const PAYMENT_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function applyPaymentDate(row, paymentDate) {
    const match = typeof paymentDate === 'string' ? paymentDate.match(PAYMENT_DATE_PATTERN) : null;
    if (!match) return row;
    return {
        ...row,
        payment_date: paymentDate,
        date: `${match[3]}/${match[2]}/${match[1]}`,
        refYear: Number(match[1]),
        refMonth: match[2]
    };
}

export function mergeDraftRows(sourceData, draftRows, draftExists) {
    const overridesById = new Map(draftRows.map(row => [row.reservation_id, row]));
    const sourceIds = new Set(sourceData.map(row => row.id));
    const mergedData = sourceData.map(row => {
        const override = overridesById.get(row.id);
        if (!override) return row;

        const ttc = parseFloat(override.ttc) || 0;
        const ht = ttc / 1.20;
        const tva = ttc - ht;
        return applyPaymentDate({
            ...row,
            ttc: ttc.toFixed(2),
            tva: tva.toFixed(2),
            ht: ht.toFixed(2),
            moyen: override.moyen,
            client: override.client
        }, override.payment_date);
    });

    const selected = new Set(sourceData.map(row => row.id));
    if (draftExists) {
        draftRows.forEach(row => {
            if (!sourceIds.has(row.reservation_id)) return;
            if (row.selected === false) selected.delete(row.reservation_id);
            if (row.selected === true) selected.add(row.reservation_id);
        });
    }

    return { mergedData, selected };
}

export function selectPreviewRows(previewData, selectedRows) {
    return previewData.filter(row => selectedRows.has(row.id));
}
